(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  function setupFooterAccordion() {
    const isMobile = window.innerWidth <= 749;
    const headings = document.querySelectorAll('.footer__blocks-wrapper .footer-block__heading');

    headings.forEach((heading) => {
      const content = heading.nextElementSibling;

      const newHeading = heading.cloneNode(true);
      heading.parentNode.replaceChild(newHeading, heading);

      if (isMobile) {
        content.style.maxHeight = '0';
        content.style.overflow = 'hidden';
        content.style.transition = 'max-height 0.3s ease';

        newHeading.style.cursor = 'pointer';

        newHeading.addEventListener('click', function () {
          const isOpen = newHeading.classList.contains('is-open');
          document.querySelectorAll('.footer__blocks-wrapper .footer-block__heading').forEach((h) => {
            const c = h.nextElementSibling;
            if (c) {
              c.style.maxHeight = '0';
              h.classList.remove('is-open');
            }
          });
          if (!isOpen) {
            content.style.maxHeight = content.scrollHeight + 'px';
            newHeading.classList.add('is-open');
          }
        });
      } else {
        content.style.maxHeight = 'none';
        content.style.overflow = 'visible';
        newHeading.classList.remove('is-open');
        newHeading.style.cursor = 'default';
      }
    });
  }

  setupFooterAccordion();
  window.addEventListener('resize', setupFooterAccordion);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener("DOMContentLoaded", function () {

    const underline = document.querySelector(".navigation__underline");

    // Select all summary menu items
    const menuItems = document.querySelectorAll(".header__inline-menu .list-menu header-menu summary");

    menuItems.forEach(item => {
        item.addEventListener("mouseenter", function () {

            const rect = this.getBoundingClientRect();

            underline.style.width = rect.width + "px";
            underline.style.left = rect.left + window.scrollX + "px";
            underline.style.transition = "all 0.25s ease";
        });
    });

    // Mouse leave on main navigation
    const mainNav = document.querySelector(".main-navigation");

    mainNav.addEventListener("mouseleave", function () {

        underline.style.width = "100%";
        underline.style.left = "0";
        underline.style.transition = "all 0.25s ease";
    });

});


  } catch(e) { console.error(e); }
})();
})();
